
import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCartStore } from '@/store/useCartStore';
import { cn } from '@/lib/utils';

interface CartButtonProps {
  className?: string;
  iconSize?: number;
  showCount?: boolean;
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link' | 'destructive';
  iconColor?: string;
  asButton?: boolean;
}

const CartButton: React.FC<CartButtonProps> = ({ 
  className,
  iconSize = 20, 
  showCount = true,
  variant = 'ghost',
  iconColor = 'currentColor',
  asButton = true
}) => {
  const { toggleCart, totalItems } = useCartStore();
  const itemCount = totalItems();
  
  // If we want to render just the icon (like the other navbar icons)
  if (!asButton) {
    return (
      <div 
        onClick={toggleCart}
        className={cn("relative cursor-pointer", className)}
      >
        <ShoppingCart 
          size={iconSize} 
          strokeWidth={1.5} 
          color={iconColor} 
        />
        
        {showCount && itemCount > 0 && (
          <span className="absolute -top-1 -right-1 flex items-center justify-center bg-red-600 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 z-10">
            {itemCount > 99 ? '99+' : itemCount}
          </span>
        )}
      </div>
    );
  }
  
  // Original button implementation
  return (
    <Button 
      variant={variant}
      size="icon"
      onClick={toggleCart}
      className={cn("relative", className)}
      aria-label="Shopping cart"
    >
      <ShoppingCart size={iconSize} strokeWidth={1.5} className="text-inherit" color={iconColor} />
      
      {showCount && itemCount > 0 && (
        <span className="absolute -top-1 -right-1 flex items-center justify-center bg-red-600 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 z-10">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </Button>
  );
};

export default CartButton;
